/* Monavida landers (USA): aftelklok tot middernacht, vaste knop onderaan en zacht verschijnen bij scrollen.
   Wordt door meerdere mv-lander-secties geladen; draait één keer per pagina. Werkt opnieuw na een
   sectie-herlaad in de theme editor (shopify:section:load). */
(function () {
  if (window.mvLander) return;

  function twee(n) { return (n < 10 ? '0' : '') + n; }

  function klokken() {
    var vakken = document.querySelectorAll('[data-mvl-klok]');
    if (!vakken.length) return;
    function tik() {
      var nu = new Date();
      var middernacht = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1, 0, 0, 0, 0);
      var over = Math.max(0, Math.floor((middernacht - nu) / 1000));
      var delen = { u: Math.floor(over / 3600), m: Math.floor(over / 60) % 60, s: over % 60 };
      vakken.forEach(function (vak) {
        ['u', 'm', 's'].forEach(function (k) {
          var el = vak.querySelector('[data-mvl-' + k + ']');
          if (el) el.textContent = twee(delen[k]);
        });
      });
    }
    tik();
    if (!window.mvLander.klokTimer) window.mvLander.klokTimer = setInterval(tik, 1000);
  }

  function plakbalk() {
    var balk = document.querySelector('[data-mvl-plak]');
    if (!balk || !('IntersectionObserver' in window)) return;
    var vanaf = Number(balk.dataset.vanaf) || 600;
    var inBeeld = new Set();
    function bijwerken() {
      balk.classList.toggle('is-zichtbaar', window.scrollY > vanaf && inBeeld.size === 0);
    }
    var io = new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        if (it.isIntersecting) inBeeld.add(it.target); else inBeeld.delete(it.target);
      });
      bijwerken();
    });
    document.querySelectorAll('[data-mvl-aanbod]').forEach(function (el) { io.observe(el); });
    var gepland = false;
    window.addEventListener('scroll', function () {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(function () { gepland = false; bijwerken(); });
    }, { passive: true });
    bijwerken();
  }

  function verschijnen() {
    var els = document.querySelectorAll('.mvl-verschijn:not(.is-zicht)');
    if (!els.length) return;
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rustig || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-zicht'); });
      return;
    }
    var io = new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        if (it.isIntersecting) { it.target.classList.add('is-zicht'); io.unobserve(it.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function start() {
    klokken();
    plakbalk();
    verschijnen();
  }

  window.mvLander = { start: start, klokTimer: null };
  document.documentElement.classList.add('mvl-js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
